module.exports = __webpack_public_path__ + "img/27_76.9dbd313f.png";